import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsCountryOfOriginStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const countryOfOriginStyles: ProductDetailsCountryOfOriginStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = countryOfOriginStyles;

const ProductDetailsCountryOfOrigin: React.FC<Props> = ({ product }) => {
    const expectedCOO = product.properties["expectedCOO"];

    if (!expectedCOO) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p" data-test-selector="expected-coo">
            <Typography {...styles.labelText}>{translate("COO")}:</Typography>
            {expectedCOO}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCountryOfOrigin),
    definition: {
        displayName: "Expected Country of Origin",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
